import { createAsyncThunk } from '@reduxjs/toolkit';
import { activeSnack } from '../store/common';
import { get } from './http';

export const getAllCarDelivery = createAsyncThunk(
  'car-delivery/list',
  async ({ page, search, dispatch, limit, sortBy }) => {
    try {
      const URL = `/delivery/user/all?page=${page && page}&search=${search && search}&limit=${limit && limit}&sortBy=${
        sortBy && sortBy
      }`;

      const response = await get(URL);
      if (response) {
        return {
          list: response?.deliveries,
          total: response?.total,
        };
      }
      return dispatch(activeSnack({ type: 'error', message: 'something went wrong' }));
    } catch (error) {
      dispatch(activeSnack({ type: 'error', message: error?.response?.data?.message }));
      throw error?.response?.data?.message;
    }
  }
);
